/**
 * 运行期配置：把构建期注入的环境变量收敛到唯一入口。
 *
 * 只读取 `VITE_` 前缀的变量。这是 Vite 的约定：不带前缀的变量不会进客户端产物，
 * 因此 `.env` 里的 `TURN_KEY_*` 机密永远不会被打包到前端。
 *
 * 默认值即「同源相对路径 /turn」，所以不建 `.env` 也能正常开发与构建。
 */
export interface AppConfig {
  /** TURN 临时凭证端点；未配置 → undefined，由 `@games/net` 回退到 `'/turn'` */
  readonly turnEndpoint: string | undefined
}

function readTurnEndpoint(): string | undefined {
  const raw: unknown = import.meta.env.VITE_TURN_ENDPOINT
  if (typeof raw !== 'string') return undefined
  const trimmed = raw.trim()
  return trimmed === '' ? undefined : trimmed
}

export const appConfig: AppConfig = {
  turnEndpoint: readTurnEndpoint(),
}
